export default __webpack_public_path__ + "static/media/broken-link-icon.906e0f2c.svg";